import React, { useContext } from 'react';
import { AppContext } from '../context';
import PageContent from '../components/PageContent';
import AddressData from '../components/AddressData';
import Section from '../components/Section';
import { FlatButton } from '../components/Button';
import { useValidation } from '../hooks';
import DataConsentQuestion from '../components/DataConsentQuestion';

const MobileAddressPage = () => {
  const { userData, setContext, ibcLogged } = useContext(AppContext);
  const [addressDataRef, validateAddressData] = useValidation();

  const submit = () => {
    const addressData = validateAddressData();

    if (addressData.invalid) {
      return;
    }

    setContext({
      userData: {
        pessoa: {
          ...userData.pessoa,
          ...addressData.value,
        },
      },
      addressResgistered: true,
      navigateTo: '/contato',
    });
  };

  return (
    <PageContent step={3}>
      <AddressData
        ref={addressDataRef}
        addressData={userData?.pessoa?.endereco}
        shouldQuery={!ibcLogged}
        setContext={setContext}
      />
      <DataConsentQuestion marginBottom />
      <Section inlineChildren flexEnd noPadding bgTransparent>
        <FlatButton
          column
          hasArrow
          back
          arrowDirection="left"
          arrowSize={5}
          onClick={() => {
            setContext({
              navigateTo: '/cadastro',
            });
          }}
          margin
        >
          Voltar
        </FlatButton>
        <FlatButton
          column
          hasArrow
          inverse
          arrowDirection="right"
          arrowSize={5}
          onClick={submit}
        >
          Continuar
        </FlatButton>
      </Section>
    </PageContent>
  );
};

export default MobileAddressPage;
